export default "__VITE_ASSET__DkwW2OKs__"